import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import logo from '../../images/site_logo/LOGO.svg'
import MobileMenu from '../MobileMenu/MobileMenu'

const Header = (props) => {

    const [mobailActive, setMobailState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return (

        <header className="site_header site_header_1">
            {/* <div className="header_top text-center">
                <div className="container">
                    <p className="m-0">Subscribe us and receive <b>20% bonus</b> discount on checkout. <Link onClick={ClickHandler} to="/pricing"><u>Learn more</u> <i className="fa-solid fa-angle-right"></i></Link></p>
                </div>
            </div> */}
            <div className={`header_bottom stricky  ${isSticky ? 'stricked-menu stricky-fixed' : ''}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-2 col-lg-2 col-5">
                            <div className="site_logo">
                                <Link onClick={ClickHandler} className="site_link" to="/">
                                    <img src={logo} alt="Site Logo" />
                                </Link>
                                {/* <div className="badge bg-danger-subtle text-danger">We’re Hiring</div> */}
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-7 col-2 text-center">
                            <nav className="main_menu navbar navbar-expand-lg">
                                <div className="main_menu_inner collapse navbar-collapse" id="main_menu_dropdown">
                                    <ul className="main_menu_list unordered_list justify-content-center">

                                        {/* <li className="dropdown">
                                            <Link onClick={ClickHandler} className="nav-link" to="/" id="home_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                              Features
                                            </Link>
                                            <ul className="dropdown-menu" aria-labelledby="home_submenu">
                                                <li><Link onClick={ClickHandler} to="/">IT Solution</Link></li>
                                            </ul>
                                        </li>
                                        
                                        <li className="dropdown">
                                            <Link onClick={ClickHandler} className="nav-link" to="/" id="portfolio_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                              Resources
                                            </Link>
                                            <ul className="dropdown-menu" aria-labelledby="portfolio_submenu">
                                                <li><Link onClick={ClickHandler} to="/about">About</Link></li>
                                            </ul>
                                        </li>
                                        */}

                                        

                                        <li><Link onClick={ClickHandler} to="/about">About Us</Link></li>
                                        <li><Link onClick={ClickHandler} to="/pricing">Pricing</Link></li>
                                        <li className="dropdown">
                                            <Link onClick={ClickHandler} className="nav-link" to="/" id="company_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                              Free Tools
                                            </Link>
                                            <ul className="dropdown-menu" aria-labelledby="company_submenu">
                                                <li><a href="https://easemyhotel.io/break-even-occupancy-calculator.html" target='_blank' >Break-even Occupancy Calculator</a></li>
                                                <li><a href="https://easemyhotel.io/ota-commission-leakage-direct-booking-roi-calculator.html" target='_blank' >OTA Commission Leakage</a></li>
                                                <li><a href="https://easemyhotel.io/revpar-adr-occupancy-calculator.html" target='_blank' >RevPAR / ADR / Occupancy Calculator</a></li>
                                                <li><a href="https://easemyhotel.io/food-cost-menu-engineering-tool.html" target='_blank' >Food Cost % + Menu Engineering Tool</a></li>

                                            </ul>
                                        </li> 
                                        <li><Link onClick={ClickHandler} to="/contact">Contact Us</Link></li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                        <div className="col-xl-4 col-lg-3 col-5">
                            <ul className="header_btns_group unordered_list justify-content-end">
                                <li>
                                    <button className="mobile_menu_btn" onClick={() => setMobailState(!mobailActive)} type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
                                        <i className="far fa-bars"></i>
                                    </button>
                                </li>
                                
                                {/* <li><Link onClick={ClickHandler} to="/contact">Watch Demo</Link></li> */}
                                <li>
                                    <Link onClick={ClickHandler} className="btn btn-outline-light try_free_btn" to="/pricing">
                                        <span className="btn_label" data-text="Try For Free">Try For Free</span>
                                    </Link>
                                </li>
                                <li>
                                    <a className="btn btn-outline-light" href="https://app.easemyhotel.io/auth-login">
                                        <span className="btn_label" data-text="Login">Login</span>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mobail-wrap">
                    <div className={`mobail-menu ${mobailActive ? "active" : ""}`}>
                        <div className="xb-header-menu-scroll">
                            <div className="xb-menu-close xb-hide-xl xb-close" onClick={() => setMobailState(!mobailActive)}></div>
                            <nav className="xb-header-nav">
                                <MobileMenu />
                            </nav>
                        </div>
                    </div>
                    <div className="xb-header-menu-backdrop" onClick={() => setMobailState(false)}></div>
                </div>
            </div>
        </header>

    )
}

export default Header;